import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AboutpageService } from 'src/app/features/company/about/aboutpage.service';
import { CommonModule, ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-about-hero',
  templateUrl: './about-hero.component.html',
  styleUrls: ['./about-hero.component.scss'],
  imports: [CommonModule],
})
export class AboutHeroComponent implements OnInit, OnDestroy {
  scroll(el: { scrollIntoView: (arg0: { behavior: string }) => void }) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

  constructor(
    private aboutPageService: AboutpageService,
    private viewportScroller: ViewportScroller
  ) {
    this.subscriptions = [];
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  heroData: any;

  ngOnInit(): void {
    this.aboutPageService.aboutHero$.subscribe(data => {
      if (data != null) {
        this.heroData = {
          header: data.title,
          paragraph: data.content?.content[0]?.content[0]?.value,
          image: data.image,
        };
      }
    });
  }
  public onClick(elementId: string): void {
    this.viewportScroller.scrollToAnchor(elementId);
  }
}
